import './radioButton.css';
const RadioButton = (props) => {
    return (
        <div className={'radio'}>
            <input {...props} type="radio"/>
        </div>
    )
}

export default RadioButton;
